import FixtureDetails from "./FixtureDetails";
export default FixtureDetails;
